export class EditTabSettings {
	private hidden: {[browseKey: string]: string[]} = {};

	constructor(data?: any) {
		if (!data) return;
		for (let key of Object.keys(data)) {
			if (!Array.isArray(data[key])) continue;
			this.hidden[key] = data[key].map((k: any) => `${k}`);
		}
	}

	private static browseKey(browseId: number): string {
		return `Browse${browseId}`;
	}

	getHiddenTabs(browseId: number): string[] {
		return [...(this.hidden[EditTabSettings.browseKey(browseId)] || [])];
	}

	isHidden(browseId: number, tabKey: string): boolean {
		return this.getHiddenTabs(browseId).indexOf(tabKey) != -1;
	}

	setHidden(browseId: number, tabKey: string, hidden: boolean) {
		let key = EditTabSettings.browseKey(browseId);
		let tabs = this.getHiddenTabs(browseId).filter(t => t != tabKey);
		if (hidden) {
			tabs.push(tabKey);
		}
		if (tabs.length == 0) {
			delete this.hidden[key];
			return;
		}
		this.hidden[key] = tabs;
	}

	getJSON(): any {
		let result: {[browseKey: string]: string[]} = {};
		for (let key of Object.keys(this.hidden)) {
			result[key] = [...this.hidden[key]];
		}
		return result;
	}
}
